import Quill from '../quill'
const Embed = Quill.import('blots/embed')

class SuperLinkBlot extends Embed {
  static create (data) {
    let node = super.create(data)
    node.setAttribute('onclick', `window.open('${data.text}')`)
    node.setAttribute('event', 'web')
    node.setAttribute('action-type', 'link')
    node.setAttribute('url', data.text)
    node.setAttribute('params', `{"url": "${data.text}"}`)
    node.innerText = data.text
    node.setAttribute('style', 'color: #7972Fe; cursor: pointer;')
    node.setAttribute('target', '_blank')
    node.setAttribute('contenteditable', false)
    return node
  }

  // 返回节点自身的value值 用于撤销操作
  static value (node) {
    const text = node.getAttribute('url')
    const data = {
      text
    }
    return data
  }
}

SuperLinkBlot.blotName = 'superLink'
SuperLinkBlot.tagName = 'action'
SuperLinkBlot.className = 'ks-quill-super-link'

export default SuperLinkBlot



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/blot/link.js